<template>
  <h2 class="section-title">
    <slot />
  </h2>
</template>

<script>
export default {
  name: 'SectionTitle'
}
</script>

<style lang="sass">
.section-title
  margin: 60px 0 30px
</style>



// WEBPACK FOOTER //
// src/components/ui/SectionTitle.vue